import { Adapter } from './adapter';
import { Category } from '../models/_index';
import { VideoCategoryInterface } from '@app/interfaces/_index';

/**
 * Adapt raw service CMS Category object to Category model used for Videos
 * NOTE: The item fields are the default json property names.
 */
export class CategoryAdapter implements Adapter<Category> {
  /**
   * Adapt data item into a Category model.
   * @param item - data item Video Category Interface to be transformed
   * @returns - returns an adapted Category model
   */
  adapt(item: VideoCategoryInterface): Category {
    let category: Category;
    if (item) {
      category = new Category(item.count, item.name, item.slug, item.description);
    }
    return category;
  }
}
